import html2canvas from 'html2canvas';
import karteCustonEventClient from '../common/karte/custom_event';

// レシピカードダウンロード許可後、画面リダイレクトが行われ発火するイベント
const checkDownloadExecutor = () => {
  const downloadExecutor = document.querySelector('.RecipeCardsDownload-downloadExecutor');
  if (downloadExecutor) {
    execDownload();
    downloadExecutor.remove();
  }
}

window.addEventListener('load', ()=> {
  checkDownloadExecutor();
})

const execDownload = () => {
  const downloadTarget = document.querySelector('.RecipeCardsDownload-downloadTarget') as HTMLElement;
  downloadTarget.classList.remove('is-preview');
  html2canvas(downloadTarget, { allowTaint: true, scrollX: -window.scrollX, scrollY: -window.scrollY }).then((canvas: HTMLCanvasElement) => {
    const tmpLink = document.createElement('a');
    tmpLink.href = canvas.toDataURL('image/jpeg');
    tmpLink.download = 'recipe_card.jpg';
    tmpLink.click();
  });
  downloadTarget.classList.add('is-preview');
}

document.addEventListener('DOMContentLoaded', () => {
  const handleClickDownloadButton = () => {
    const RecipeDownloadButton = document.querySelector<HTMLElement>('.RecipeCardsDownload-RecipeDownloadButton');
    const QrDownloadButton = document.querySelector<HTMLElement>('.RecipeCardsDownload-QrDownloadButton');
    const ThumbnailDownloadButton = document.querySelector<HTMLElement>('.RecipeCardsDownload-ThumbnailDownloadButton');
    const radioButtons = document.querySelectorAll<HTMLFormElement>('.RecipeCardDownload-formRadioButton');

    RecipeDownloadButton?.addEventListener('click', (e) => {
      const checkedRadioButton = Array.from(radioButtons).filter((radioButton) => radioButton.checked)[0]
      const isDownloaded = parseInt(checkedRadioButton.getAttribute('data-downloaded') as string, 10);

      // KARTEに登録イベントを送信
      sendKarteEvent(
        'download_content',
        'recipe_cards',
        'レシピカードをダウンロードしました'
      );

      if (isDownloaded) {
        e.preventDefault();
        execDownload();
      } else {
        const unlimitedPlan = checkedRadioButton.getAttribute('data-unlimited-plan') === 'true';
        const downloadableCount = parseInt(checkedRadioButton.getAttribute('data-downloadable-count') as string, 10);
        if (!unlimitedPlan) {
          const result = window.confirm(`このレシピをダウンロードしますか？使用可能な残りレシピ数 ${downloadableCount} → ${downloadableCount - 1}`)
          if (!result) {
            e.preventDefault();
          }
        }
      }
    });

    QrDownloadButton?.addEventListener('click', (e) => {
      let isDownloaded = 0;
      // ラジオボタンの中にダウンロード済みのものがあるかどうか
      radioButtons.forEach((radioButton) => {
        if (parseInt(radioButton.getAttribute('data-downloaded') as string, 10)) {
          isDownloaded = 1;
        }
      })

      // KARTEに登録イベントを送信
      sendKarteEvent(
        'download_content',
        'recipe_card_qr_code',
        'QRコードをダウンロードしました'
      );

      if (isDownloaded) {
        e.preventDefault();
        // QRコードをURLからダウンロード
        const qrCodeElement = document.querySelector('.RecipeCard-qr') as HTMLImageElement;
        const imageUrl = qrCodeElement.src;
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = 'qr_code.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });

    ThumbnailDownloadButton?.addEventListener('click', (e) => {
      let isDownloaded = 0;
      // ラジオボタンの中にダウンロード済みのものがあるかどうか
      radioButtons.forEach((radioButton) => {
        if (parseInt(radioButton.getAttribute('data-downloaded') as string, 10)) {
          isDownloaded = 1;
        }
      })

      // KARTEに登録イベントを送信
      sendKarteEvent(
        'download_content',
        'recipe_card_thumbnail',
        'サムネイルをダウンロードしました'
      );

      if (isDownloaded) {
        e.preventDefault();
        const dataThumbnailUrl = document.querySelector('.RecipeCard-recipeThumbnail')?.getAttribute('data-thumbnail-url');
        let fileExtension;
        let imageUrl;

        if (dataThumbnailUrl) {
          imageUrl = dataThumbnailUrl;
          fileExtension = dataThumbnailUrl.split('.').pop()?.toLowerCase() || 'jpg'; // 拡張子を取得出来ない場合はjpgでダウンロードする
        } else {
          const thumbnailElement = document.querySelector('.RecipeCard-recipeThumbnail') as HTMLImageElement;
          imageUrl = thumbnailElement.src
          fileExtension = 'jpg'
        }

        if (fileExtension.includes('png')) {
          downloadImage(imageUrl, 'thumbnail.png'); // PNG画像の場合
        } else if (fileExtension.includes('jpg') || fileExtension.includes('jpeg')) {
          downloadImage(imageUrl, 'thumbnail.jpg'); // JPGまたはJPEG画像の場合
        }
      }
    });
  }

  const downloadImage = (url: string, filename: string) => {
    fetch(url)
      .then(response => response.blob()) // バイナリデータを取得
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      })
      .catch(console.error);
  }

  const adjustmentTitle = () => {
    const adjustmentTitleTextArea = document.querySelector('.RecipeCardsDownload-recipeCardTitleAdjustmentTextArea textarea') as HTMLTextAreaElement;
    const caution = document.querySelector('.RecipeCardsDownload-recipeCardTitleAdjustmentCaution') as HTMLElement;
    const adjustedTitleInput = document.getElementById('adjusted_title') as HTMLInputElement;
    const recipeCards = document.querySelectorAll('.RecipeCard');
    if (adjustmentTitleTextArea) {
      [].forEach.call(recipeCards, recipeCard => {
        const recipeCardTitles = (recipeCard as HTMLElement).querySelectorAll('span.RecipeCard-title');
        if (recipeCardTitles.length == 1) {
          // 1行なら処理しない
          adjustmentTitleTextArea.disabled = true;
          return;
        }
        const upperTitle = recipeCardTitles[0] as HTMLElement;
        const lowerTitle = recipeCardTitles[1] as HTMLElement;
        const inlineTitle = upperTitle.innerText + lowerTitle.innerText;
        adjustmentTitleTextArea.addEventListener('keyup', () => {
          const textValue = adjustmentTitleTextArea.value;
          const values = textValue.split(/\r\n|\r|\n/);
          const upperValue = values[0] || '';
          const lowerValue = values[1] || '';
          if (!upperValue.length) {
            caution.style.display = 'block';
            return;
          }
          if (inlineTitle == upperValue + lowerValue) {
            upperTitle.innerText = upperValue;
            lowerTitle.innerText = lowerValue;
            adjustedTitleInput.value = upperValue  + "\n" +  lowerValue;
            caution.style.display = 'none';
          } else {
            caution.style.display = 'block';
          }
          if (lowerValue.length) {
            lowerTitle.style.display = 'block';
          } else {
            lowerTitle.style.display = 'none';
          }
        });
      });
      // 初期入力
      if (adjustedTitleInput.value.length) {
        adjustmentTitleTextArea.value = adjustedTitleInput.value;
        const event = document.createEvent("KeyboardEvent");
        event.initEvent('keyup');
        adjustmentTitleTextArea.dispatchEvent(event);
      } else {
        const recipeCard = recipeCards[0] as HTMLElement;
        const recipeCardTitles = recipeCard.querySelectorAll('span.RecipeCard-title');
        if (recipeCardTitles.length == 1) {
          // 1行なら処理しない
          adjustmentTitleTextArea.disabled = true;
          return;
        }
        const upperTitle = recipeCardTitles[0] as HTMLElement;
        const lowerTitle = recipeCardTitles[1] as HTMLElement;
        adjustmentTitleTextArea.value = upperTitle.innerText + "\n" + lowerTitle.innerText;
      }
    }
  }

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 投稿したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  handleClickDownloadButton();
  adjustmentTitle();
});
